import ActionAbstract from '../../ActionAbstract';
import * as helper from '../../../helper';

class UpdateLinkCast extends ActionAbstract {

    /**
     * @param blocId : id of block
     * @param link : data of link (from & to)
     * @param cast : value of cast
    **/

    static get ID() {
        return 'actions:editor:schematic:updateLinkCast';
    }

    run(state) {
        
        let path;
        let block = null;
        [block,path] = helper.block.getBlockById( state.project, this.getParam('blocId') , true );

        let link = this.getParam('link');
        let linkIndex = helper.links.getIndexOfLink( block, link );

        if( linkIndex != -1 ){

            let compositeState = { 
                project: {},
                'editor.linkmenu.link.conversion' : this.getParam('cast')
            };
             
            compositeState.project[path+'.value.links['+linkIndex+'].conversion'] = this.getParam( 'cast' );
           
            return this.composeState(state, compositeState );
        }

        return false;
    }


}

export default UpdateLinkCast;